import {AdminApiError} from './admin-api-error';
import {ErrorCode} from './error-codes';

export {AdminApiError} from './admin-api-error';

export class UnknownDomainError extends AdminApiError {
    constructor(message: string | null) {
        super(11, message);
        this.name = 'UnknownDomainError';
    }
}

export class InvalidClientVersionError extends AdminApiError {
    constructor(message: string | null) {
        super(12, message);
        this.name = 'InvalidClientVersionError';
    }
}

export class InvalidAuthTokenError extends AdminApiError {
    constructor(message: string | null) {
        super(13, message);
        this.name = 'InvalidAuthTokenError';
    }
}

export class PlatformSessionExpiredError extends AdminApiError {
    constructor(message: string | null) {
        super(24, message);
        this.name = 'PlatformSessionExpiredError';
    }
}

export function throwForStatusCode(code: number, message: string | null): never {
    switch (code) {
        case ErrorCode.UnknownDomain:
            throw new UnknownDomainError(message);
        case ErrorCode.InvalidClientVersion:
            throw new InvalidClientVersionError(message);
        case ErrorCode.InvalidAuthToken:
            throw new InvalidAuthTokenError(message);
        case ErrorCode.PlatformSessionExpired:
            throw new PlatformSessionExpiredError(message);
        default:
            throw new AdminApiError(code, message);
    }
}
